import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Input from '../../../Shared/Form/Input'
import { withTranslation } from 'react-i18next'
import debounce from 'lodash.debounce'
import Loader from '../../../Shared/Loader'
import { getSalesToken } from '../../../../api'

class SalesTokenInput extends Component {

  constructor (props) {
    super(props)
    this.state = {
      value: props.token,
      loading: false,
      valid: undefined
    }
    this.abortController = null
  }

  componentWillUnmount () {
    if (this.abortController) {
      this.abortController.abort()
    }
  }

  componentDidMount () {
    if (this.state.value !== '') {
      this.validate()
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (
      (this.props.token !== prevProps.token && this.state.value !== this.props.token)
    ) {
      this.setState({ value: this.props.token })
      this.validate()
    }
  }

  onChange = (e) => {
    this.setState({ value: e.target.value, valid: undefined }, () => {
      this.validate()
    })
  }

  validate = debounce(() => {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
    if (this.state.value === '' || this.state.value === null) {
      this.setState({ valid: false })
      this.props.onValidated(false, this.state.value)
      return
    }
    this.abortController = new AbortController()
    this.setState({ loading: true, valid: undefined }, async () => {
      getSalesToken(this.state.value).then(async (response) => {
        let valid = false
        if (response.ok) {
          const json = await response.json()
          if (json.active === true) {
            valid = true
          }
        }
        this.setState({
          loading: false, valid: valid
        })
        this.props.onValidated(valid, this.state.value)
      })
    })
  }, 1000)

  render () {
    const isValid = (this.state.valid === true || this.state.valid === undefined || this.state.value === '' || typeof this.state.value === 'undefined' || this.state.value === null)
    const { t } = this.props
    return (
      <React.Fragment>
        {this.state.loading ? <Loader size={30}/> : null}
        <Input
          label={isValid ? this.props.label : 'Invalid'}
          message={!isValid ? t('PROMOTION_CODE') : undefined}
          disabled={false}
          onChange={this.onChange}
          value={this.state.value}
          valid={isValid}
          round={this.props.round}
        />
      </React.Fragment>
    )
  }
}

SalesTokenInput.propTypes = {
  token: PropTypes.string,
  // onValidated called with isValid, token
  onValidated: PropTypes.func.isRequired,
  label: PropTypes.string,
  round: PropTypes.bool
}

export default withTranslation()(SalesTokenInput)
